<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">Ｗ掲載設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="block-column">
          <div class="column-list">
            <label class="list-input-title">Ｐコード</label>
            <div class="list-input-content">
              <input type="text" class="pcode" value="{{kymw1310Model.pCode}}" readonly>
            </div>

            <label class="list-input-title">商品名</label>
            <div class="list-input-content">
              <input type="text" value="{{kymw1310Model.guideGoodsName}}" readonly>
            </div>

            <label class="list-input-title">規格名</label>
            <div class="list-input-content">
              <input type="text" class="guide-standard-name" value="{{kymw1310Model.guideStandardName}}" readonly>
            </div>
          </div>

          <div>
            <wj-flex-grid [style.width.px]="560" [style.height.px]="506"
              id="dtg_MultiPublish" #dtg_MultiPublish [itemsSource]="kymw1310Model.multiPublishList"
              [headersVisibility]="'Column'" [tabindex]="-1" [allowResizing]="true" [isReadOnly]="true"
              [allowSorting]="false" [allowDragging]="'None'">
              <wj-flex-grid-column [minWidth]="5" [header]="'媒体'" [width]="180" [binding]="'mediumName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'全生協'" [width]="80" [binding]="'publishFlagALL'"
                [isReadOnly]="true">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagALL" id="cb_1_{{cell.row.index}}"
                    (change)="setCoopCheckbox(cell.item, cell.item.publishFlagALL)" (mouseup)="$event.stopPropagation()"
                    [disabled]="!kymw1310Model.enableFlagALL || !kymw1310Model.editLock" [tabindex]="-1" />
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'い'" [width]="30" [binding]="'publishFlagIB'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagIB" id="cb_2_{{cell.row.index}}"
                    [disabled]="!kymw1310Model.enableFlagIB || cell.item.publishFlagALL || !kymw1310Model.editLock"
                    [tabindex]="-1" (mouseup)="$event.stopPropagation()"/>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'と'" [width]="30" [binding]="'publishFlagTO'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagTO" id="cb_3_{{cell.row.index}}"
                    [disabled]="!kymw1310Model.enableFlagTO || cell.item.publishFlagALL || !kymw1310Model.editLock"
                    [tabindex]="-1" (mouseup)="$event.stopPropagation()"/>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'ぐ'" [width]="30" [binding]="'publishFlagGU'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagGU" id="cb_4_{{cell.row.index}}"
                    [disabled]="!kymw1310Model.enableFlagGU || cell.item.publishFlagALL || !kymw1310Model.editLock"
                    [tabindex]="-1" (mouseup)="$event.stopPropagation()"/>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'ち'" [width]="30" [binding]="'publishFlagTI'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagTI" id="cb_5_{{cell.row.index}}"
                    [disabled]="!kymw1310Model.enableFlagTI || cell.item.publishFlagALL || !kymw1310Model.editLock"
                    [tabindex]="-1" (mouseup)="$event.stopPropagation()"/>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'さ'" [width]="30" [binding]="'publishFlagSA'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagSA"  id="cb_6_{{cell.row.index}}"
                    [disabled]="!kymw1310Model.enableFlagSA || cell.item.publishFlagALL || !kymw1310Model.editLock"
                    [tabindex]="-1" (mouseup)="$event.stopPropagation()"/>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'とう'" [width]="40" [binding]="'publishFlagTK'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagTK" id="cb_7_{{cell.row.index}}"
                    [disabled]="!kymw1310Model.enableFlagTK || cell.item.publishFlagALL || !kymw1310Model.editLock"
                    [tabindex]="-1" (mouseup)="$event.stopPropagation()"/>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'な'" [width]="30" [binding]="'publishFlagNA'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagNA" id="cb_8_{{cell.row.index}}"
                    [disabled]="!kymw1310Model.enableFlagNA || cell.item.publishFlagALL || !kymw1310Model.editLock"
                    [tabindex]="-1" (mouseup)="$event.stopPropagation()"/>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'に'" [width]="30" [binding]="'publishFlagNI'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagNI" id="cb_9_{{cell.row.index}}"
                    [disabled]="!kymw1310Model.enableFlagNI || cell.item.publishFlagALL || !kymw1310Model.editLock"
                    [tabindex]="-1" (mouseup)="$event.stopPropagation()"/>
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [header]="'ク'" [width]="30" [binding]="'publishFlagKU'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  <input type="checkbox" [(ngModel)]="cell.item.publishFlagKU" id="cb_10_{{cell.row.index}}"
                    [disabled]="!kymw1310Model.enableFlagKU || cell.item.publishFlagALL || !kymw1310Model.editLock"
                    [tabindex]="-1" (mouseup)="$event.stopPropagation()"/>
                </ng-template>
              </wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" class="btn-primary" (click)="eventRegist_CLICKHandler(null)" [tabindex]="0" 
            [disabled]="!kymw1310Model.editLock">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>